// extracted by mini-css-extract-plugin
var _1 = "Z6QEShIzwF";
export { _1 as "root" }
